import * as actionTypes from '../actionTypes';

const initialState = {
  allData: [],
}

const reducer = (state =initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_USER_STATEMENT_REDUCER:
            state = {
                ...state,
                allData:action.payload,
            }
            break;
        default:
            state = { ...state };
    }
    return state;
}

export default reducer;
